import styled from "styled-components";
import { ProgramContainer } from "../../ProgramBrowser/Program/styles";

export const UserContainer = styled(ProgramContainer)``;